import React from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App'

// calc viewport height and set --vh custom property as mobile browsers lie to us
// let vh = window.innerHeight * 0.01
// document.documentElement.style.setProperty('--vh', `${vh}px`)

const root = createRoot(document.getElementById('root')) // createRoot(container!) if you use TypeScript
root.render(<App tab="home" />)
